export const FLAG_GETTING_FUEL_VOUCHERS = 'FLAG_GETTING_FUEL_VOUCHERS';
export const GET_FUEL_VOUCHERS = 'GET_FUEL_VOUCHERS';
export const CLEAR_FUEL_VOUCHERS = 'CLEAR_FUEL_VOUCHERS';
export const FLAG_FUEL_VOUCHER_ACTIVITY = 'FLAG_FUEL_VOUCHER_ACTIVITY';
export const GET_FUEL_VOUCHER = 'GET_FUEL_VOUCHER';
export const CLEAR_FUEL_VOUCHER = 'CLEAR_FUEL_VOUCHER';
export const POST_FUEL_VOUCHER = 'POST_FUEL_VOUCHER';
export const PUT_FUEL_VOUCHER = 'PUT_FUEL_VOUCHER';
